import { Component } from "react";
import { compose } from "redux";

import WithdrawOrdersComponent from "./Withdraw.Orders.Component";

import BonusRegisterComponent from "./Bonus.Registration.Component";
import { ordersConnector } from "../../../services/orders/connector";
import { usersConnector } from "../../../services/users/connectors/usersConnector";
import SendBackOrdersComponent from "./SendBack.Orders.Component";

class _OrdersComponent extends Component {
  render() {
    return (
      <div className="orders-layout body-height content-padding">
        <WithdrawOrdersComponent
          {...this.props}
          withdraw={this.props.orders.withdraw}
        />
        <br />
        <hr />
        <br />
        <BonusRegisterComponent
          accountId={this.props.accountId}
          currentUser={this.props.currentUser}
        />
        <br />
        <hr />
        <br />
        <SendBackOrdersComponent
          {...this.props}
          sendBacks={this.props.orders.sendBacks}
        />
      </div>
    );
  }
}
export const OrdersComponent = compose(ordersConnector)(_OrdersComponent);
export const UserOrdersComponent = compose(
  ordersConnector,
  usersConnector,
)(_OrdersComponent);
